var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7147 9.78298C8.86017 9.78298 9.78876 8.85504 9.78876 7.71037C9.78876 6.5657 8.86017 5.63777 7.7147 5.63777C6.56922 5.63777 5.64063 6.5657 5.64063 7.71037C5.64063 8.85504 6.56922 9.78298 7.7147 9.78298Z",
    fill: "#787486"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6648 0.0279174H12.5542L4.25791 0.622064C2.32565 0.794841 0.794282 2.32513 0.621384 4.25603L0.0129992 12.5465C-0.0633909 13.3093 0.199543 14.0671 0.732035 14.6191L12.4021 26.2809C12.895 26.7554 13.5569 27.014 14.2411 26.9994C15.2879 26.9903 16.2861 26.5564 17.0065 25.7973L25.8144 17.0095C27.1825 15.876 27.3972 13.8593 26.2983 12.4635L14.5591 0.718786C14.0637 0.248174 13.4036 -0.00975933 12.7201 0.000282593L12.6648 0.0279174ZM12.7201 2.25251C12.8011 2.22706 12.888 2.22706 12.969 2.25251L24.6529 13.9282C24.7659 14.4461 24.5725 14.9829 24.1551 15.3099L15.3196 24.1392C15.0285 24.4548 14.628 24.6475 14.1996 24.6781H13.9645L2.32215 12.9472C2.28496 12.8492 2.28496 12.7411 2.32215 12.6432L2.93053 4.35275C3.03908 3.60083 3.6195 3.0041 4.36856 2.87429L12.6648 2.28015L12.7201 2.25251Z",
    fill: "#787486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/productIcon.73d08b3f69f7177e8a9eca71e660fd26.svg";
export { ForwardRef as ReactComponent };